import React from 'react';

import { Image, ImageCaption, ImageCaptionLink, ImageContainer } from './styled';
import { ImageWidgetProps } from './types';

export const ImageWidget: React.FC<ImageWidgetProps> = props => {
  return (
    <ImageContainer>
      <Image image={props.image?.locale} alt={props.caption?.locale ?? ''} />
      {props.caption && (
        <ImageCaption>
          {props.attributionLink && ( // TODO: RN - ensure styling is correct
            <ImageCaptionLink href={props.attributionLink}>Image Source</ImageCaptionLink>
          )}
          {props.caption?.locale}
        </ImageCaption>
      )}
    </ImageContainer>
  );
};
